import React from 'react'
import InputLabel from '@material-ui/core/InputLabel';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import styles from './Catalog.module.css'
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Button from '@material-ui/core/Button';
import { useHistory } from 'react-router-dom';
import Navbar from './Navbar'
import Pets from '@material-ui/icons/Pets';
import Shared from '../services/Shared';
import Api from '../services/Api'

export default function Catalog() {

    const [courses, setCourses] = React.useState([]);
    const history = useHistory();
    const [subject, setSubject] = React.useState('Art');
    const [subjects, setSubjects] = React.useState(['Art']);

    React.useEffect(() => {
        getSubjects();
    }, []); //[] means run one time after component loads, [subject] means run when subject mutates, missing argument means run after every render

    React.useEffect(() => {
        if (!subject) return;

        Api.getCoursesBySubject(subject, response => {
            setCourses(response);
        });
    }, [subject]);

    function getSubjects() {
        Api.getSubjects( response => {
            setSubjects(response);
        });
    }

    function onRegister(e, id) {
        history.push(`${Shared.path.register}?course=${id}`);
    }

    function onSubject(e) {
        const sub = e.target.value;
        setSubject(sub);
    }

    return (
        <>
            <Navbar></Navbar>
            <div className={styles.bg}>
                <div className={styles.head}>
                    <div>
                        <h1>Catalog &nbsp; <Pets /> </h1>
                    </div>
                    <div>
                        <FormControl variant="filled" className={styles.subSelect}>
                            <InputLabel id="subject">Subject</InputLabel>
                            <Select
                                labelId="subject"
                                id="filled"
                                value={subject}
                                onChange={onSubject}
                            >
                                <MenuItem value="">
                                    <em>None</em>
                                </MenuItem>
                                {subjects.map(s => {
                                    return <MenuItem key={s} value={s}>{s}</MenuItem>;
                                })}
                            </Select>
                        </FormControl>
                    </div>
                </div>

                <div className={styles.cardDiv}>
                    <div className={styles.cards}>
                        {courses?.map(c => {
                            return (
                                <Card className={styles.card} key={c.id}>
                                    <CardContent>
                                        <div className={styles.cardHead}>
                                            <div className={styles.name}>{c.name}</div>
                                            <div className={styles.id}>Catalog # {c.id}</div>
                                        </div>
                                        <div className={styles.details}>{c.details}</div>
                                        <div className={styles.footer}>
                                            <div>Textbook: {c.textbook}</div>
                                            <div>Credits: {c.credits}</div>
                                        </div>
                                    </CardContent>
                                    <div className={styles.button}>
                                        <Button size="large" onClick={e => onRegister(e, c.id)}>Register</Button>
                                    </div>
                                </Card>
                            )
                        })}
                    </div>
                </div>
            </div>
        </>
    )
}